import type { NotificationTone } from './types';

/** Tone → the semantic classes for the round icon chip. */
export const TONE_ICON_CLASS: Record<NotificationTone, string> = {
  WARN: 'bg-warn-bg text-warn-text',
  SUCCESS: 'bg-success-bg text-success-text',
  ERROR: 'bg-error-bg text-error-text',
  INFO: 'bg-info-bg text-info-text'
};
